import { PageHeader } from "../components/Layout";
import WheelView from "../components/WheelView";

export default function PenaltiesWheel() {
  return (
    <div className="p-5 md:p-8 max-w-7xl mx-auto">
      <PageHeader title="Ruota delle Penitenze" subtitle="Penitenze divertenti e fair-play per il prossimo round." accent="red" />
      <WheelView slug="penalty" accentType="penalty" />
    </div>
  );
}
